export { GraphQLClient, gql, rawRequest, request } from 'graphql-request';

function entries(obj) {
  return Object.entries(obj);
}

export { entries };
